import { lazy, Suspense, useEffect, useRef, useState } from "react";
import "./styles/BhpFirstFoldPage.css";
import { IonButton, IonIcon, IonSpinner } from "@ionic/react";
import {
  AdvertisingDetailsType,
  BusinessDetailsType,
} from "../pages/BussinessHomePage";
import {
  arrowRedoSharp,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronBack,
  close,
  documentText,
  location,
  menuSharp,
  micSharp,
  navigate,
  pricetag,
  qrCodeOutline,
  searchSharp,
} from "ionicons/icons";
import { useInView } from "react-intersection-observer";
import { getSessionDetails } from "../common/cookies";
import axios from "axios";
import {
  API_SECURE_KEY,
  getFileThumbnailDB,
  getPreEmptiveSearchResults,
  IDIGIZEN_BACKEND_URL,
} from "../types/constants";
import {
  useAppDispatch,
  useAppSelector,
  useCustomToast,
  useStringToast,
} from "../app/hooks";
import {
  fetchImgThumbnailData,
  truncateString,
} from "../common/commonFunctions";
import { loginInfoActions } from "../store/login-info-slice";
import { BhpCampaignType } from "../types/data_types";
import LazyLoaderSpinner from "./LazyLoaderSpinner";
const BhpTicker = lazy(() => import("./BhpTicker"));

const BhpFirstFoldPage: React.FC<{
  visitCount: { shopVisits?: number; marketVisits: number };
  businessDetails: BusinessDetailsType;
  logoImgData: string;
  vypzeePage?: boolean;
  onSearchClick: (val: string) => void;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
  onShare: () => void;
  onMenuClick: () => void;
  onClickHeaderCTA: () => void;
  setSubheaderVisible: (val: boolean) => void;
  logoMode?: boolean;
  headerFontColor?: string;
  hideFooter?: boolean;
  ctaBtnBg?: string;
  ctaBtnColor?: string;
  bannerCtaBtnDisable?: boolean;
  marketCluster?: boolean;
  noBannerSubtext?: boolean;
  disableHeaderCta?: boolean;
  footerOverride?: {
    image?: { fileName: string; rotation: number };
    url?: string;
    imagePosition?: string;
  };
  openQR: () => void;
  openSearch?: () => void;
  // verifyNow?: () => void;
  adData?: AdvertisingDetailsType[];
  campaignData?: BhpCampaignType;
  openAllCampaignPromo?: () => void;
}> = (props) => {
  const [pageHeaderRef, pageHeaderInView] = useInView();

  useEffect(() => {
    props.setSubheaderVisible(!pageHeaderInView);
  }, [pageHeaderInView]);

  const [loadingPreEmpt, setLoadingPreEmpt] = useState(false);
  //   const [search, setSearch] = useState("");
  const [preEmptiveSearch, setPreEmptiveSearch] = useState<string>("");
  const [preEmptiveSearchList, setPreEmptiveSearchList] = useState<
    { type: string; value: string }[]
  >([]);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const showPrempts = !!preEmptiveSearch;
  const stringToast = useStringToast();
  const { token } = getSessionDetails();
  const AUTH_PARAMS = `token=${token}&Authorization=${API_SECURE_KEY}`;

  const preemptiveListJsx = (
    <div
      style={{
        position: "absolute",
        width: "100%",
        maxHeight: "300px",
        top: "100%",
        left: 0,
        zIndex: "1000000000",
        border: "1px solid var(--ion-color-medium)",
        overflow: "scroll",
        background: "white",
        display: !!showPrempts ? "block" : "none",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "var(--ion-color-tertiary)",
          fontSize: "1.2rem",
          borderBottom: "1px solid var(--ion-color-medium)",
          padding: "5px 15px",
          position: "sticky",
          top: 0,
          zIndex: "100",
          background: "white",
        }}
        onClick={() => {
          searchBackend(preEmptiveSearch);
        }}
      >
        <div>
          Search for <b>"{preEmptiveSearch}"</b>
        </div>
        <IonButton fill="clear" color={"medium"} size="small">
          <IonIcon icon={searchSharp} />
        </IonButton>
      </div>
      {loadingPreEmpt && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px",
          }}
        >
          <IonSpinner color={"medium"} />
        </div>
      )}
      {!loadingPreEmpt &&
        preEmptiveSearchList.map((el) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "5px 15px",
                borderBottom: "1px solid var(--ion-color-medium)",
              }}
              onClick={() => {
                searchBackend(el.value);
              }}
            >
              <div>
                <div
                  style={{
                    color: "var(--ion-color-medium)",
                    fontSize: "0.7rem",
                    paddingBottom: "5px",
                  }}
                >
                  {el.type}
                </div>
                <div
                  style={{
                    color: "var(--ion-color-dark)",
                    fontSize: "1.1rem",
                  }}
                >
                  {el.value}
                </div>
              </div>
              <IonButton fill="clear" color={"medium"} size="small">
                <IonIcon icon={searchSharp} />
              </IonButton>
            </div>
          );
        })}
    </div>
  );

  useEffect(() => {
    if (!!preEmptiveSearch) {
      if (!!timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(triggerBackendSearch, 800);
    }
  }, [preEmptiveSearch]);
  /*****************************************************************
   * Name : triggerBackendSearch
   * Description : Function to trigger the search
   *****************************************************************/
  const triggerBackendSearch = () => {
    const date = new Date();
    let { id, session } = getSessionDetails();
    setLoadingPreEmpt(true);

    axios
      .get(`${IDIGIZEN_BACKEND_URL}/${getPreEmptiveSearchResults}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: API_SECURE_KEY,
        },
        params: {
          Authorization: API_SECURE_KEY,
          searchString: preEmptiveSearch,
          marketId: props.businessDetails.id,
        },
      })
      .then((res) => {
        console.log("Search results ", res);
        setPreEmptiveSearchList(res.data.data);
        setLoadingPreEmpt(false);
      })
      .catch((err) => {
        setLoadingPreEmpt(false);
      });
  };

  const searchBackend = (str: string) => {
    // setSearch(str);
    // setPreEmptiveSearch(str);
    setPreEmptiveSearch("");
    props.onSearchClick(str);
  };

  const [logoImgData, setLogoImgData] = useState(undefined);
  const presentToast = useCustomToast();
  const { id, role } = getSessionDetails();
  const canVerify =
    !!id && (role === "IDIGIZENSUPERADMIN" || role === "MARKETSUPERADMIN");
  // const isMobile =
  //   useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;
  const dispatch = useAppDispatch();
  const verifyMode = useAppSelector(
    (state) => state.loginInfoSelection.bhpVerify
  );

  useEffect(() => {
    const getLogoImg = async () => {
      try {
        const data = await fetchImgThumbnailData(
          props.businessDetails.logoImgObj.fileName,
          false
        );
        setLogoImgData(data);
      } catch (e) {
        presentToast(e);
      }
    };
    console.log(
      "Get logo data ",
      props.logoMode ? "YES" : "NO",
      " logo object ",
      props.businessDetails?.logoImgObj
    );
    if (!!props.businessDetails?.logoImgObj && props?.logoMode) getLogoImg();
  }, [props.logoMode, props.businessDetails]);

  return (
    <div className="bhp-first-fold-page-top">
      <div
        className="bhp-first-fold-header"
        style={{
          justifyContent: props?.disableHeaderCta ? "flex-end" : undefined,
        }}
      >
        {/* {!!props.disableHeaderCta && (
          <div
            style={{ height: isMobile ? "30px" : "40px", width: "100px" }}
            onClick={() => {
              window.location.assign("https://abanteindia.com/");
            }}
          >
            <img
              src="assets/Abante.png"
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
        )} */}
        {!props.disableHeaderCta && (
          <IonButton
            color={"medium"}
            fill="clear"
            size="small"
            onClick={props.onClickHeaderCTA}
          >
            {!props.vypzeePage && (
              <>
                <IonIcon icon={chevronBack} slot="start" />{" "}
                <span
                  style={{
                    textTransform: "none",
                    color: props.headerFontColor
                      ? props.headerFontColor
                      : "var(--ion-color-bhp-vypzee-dark)",
                  }}
                >
                  {truncateString(
                    props.businessDetails.isMarket
                      ? "Local Markets"
                      : props.businessDetails.marketName,
                    25
                  )}
                </span>
              </>
            )}
            {!!props.vypzeePage && (
              <span
                style={{
                  textTransform: "none",
                  color: props?.headerFontColor
                    ? props.headerFontColor
                    : "var(--ion-color-bhp-vypzee-dark)",
                }}
              >
                What is Vypzee?
              </span>
            )}
          </IonButton>
        )}
        <div style={{ display: "flex", alignItems: "center" }}>
          {!!canVerify && !props.businessDetails.verified && (
            <IonButton
              color={verifyMode ? "success" : "dark"}
              fill="solid"
              size="small"
              onClick={() => {
                dispatch(
                  loginInfoActions.updateBhpVerify({
                    loaded: !verifyMode,
                  })
                );
              }}
            >
              <IonIcon
                icon={verifyMode ? checkmarkCircle : checkmarkCircleOutline}
              />
            </IonButton>
          )}
          {!!props.businessDetails.isMarket && (
            <IonButton
              color={"medium"}
              fill="clear"
              size="small"
              onClick={props.openQR}
            >
              <IonIcon icon={qrCodeOutline} />
            </IonButton>
          )}
          {!props.businessDetails.isMarket && (
            <IonButton
              color={"medium"}
              fill="clear"
              size="small"
              onClick={props.openSearch}
            >
              <IonIcon icon={searchSharp} />
            </IonButton>
          )}
          <IonButton
            color={"medium"}
            fill="clear"
            size="small"
            onClick={props.onShare}
          >
            <IonIcon icon={arrowRedoSharp} />
          </IonButton>
          <IonButton
            color={"medium"}
            fill="clear"
            size="small"
            onClick={props.onMenuClick}
          >
            <IonIcon icon={menuSharp} />
          </IonButton>
        </div>
      </div>
      <div
        className="bhp-first-fold-page-top-search-wrapper"
        style={{
          marginTop: !props.businessDetails.isMarket
            ? "5px"
            : props.vypzeePage
            ? "40px"
            : "10px",
          marginBottom: props.businessDetails.isMarket ? "10px" : "20px",
          display: !props.businessDetails.isMarket ? "none" : undefined,
        }}
      >
        <div
          className="bhp-first-fold-logo"
          style={{
            height: props.vypzeePage ? "100px" : "130px",
            // paddingBottom: !props.vypzeePage ? "10px" : undefined,
          }}
          // style={{
          //   border: !props.vypzeePage
          //     ? "1px solid var(--ion-color-medium)"
          //     : undefined,
          //   boxShadow: !props.vypzeePage
          //     ? "0 3px 10px rgba(0, 0, 0, 0.2)"
          //     : undefined,
          // }}
        >
          <div
            className="bhp-first-fold-title"
            style={{
              paddingBottom: !props.vypzeePage ? "10px" : undefined,
              zIndex: props?.vypzeePage || props?.logoMode ? -1 : 1,
            }}
          >
            {!!props.businessDetails.isMarket && (
              <h1
                style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "30px",
                  textShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                }}
                className="bhp-first-fold-poppins-font"
              >
                {props.businessDetails.name}
              </h1>
            )}
            {props.businessDetails.marketType !== "RWA" && (
              <div
                style={{
                  fontSize: "0.7rem",
                  textShadow: "none",
                  color: "var(--ion-color-bhp-gray)",
                }}
              >
                {props.businessDetails?.address}
              </div>
            )}
          </div>
          {!!(props.vypzeePage || props?.logoMode) && (
            <img
              style={{
                height: "100%",
                width: "100%",
                objectFit: "contain",
              }}
              src={props?.logoMode ? logoImgData : props.logoImgData}
              alt=""
            />
          )}
        </div>
        <div
          style={{ height: !props.businessDetails.isMarket ? 0 : "15px" }}
        ></div>
        {props.businessDetails.marketType !== "RWA" && (
          <div
            style={{
              width: "90%",
              position: "relative",
              maxWidth: "800px",
            }}
          >
            <div
              style={{
                position: "absolute",
                left: "10px",
                top: "0",
                height: "100%",
                fontSize: "1.2rem",
                display: "flex",
                alignItems: "center",
                color: props?.headerFontColor
                  ? props.headerFontColor
                  : "var(--ion-color-bhp-vypzee-dark)",
              }}
            >
              <IonIcon icon={searchSharp} />
            </div>
            <div
              style={{
                position: "absolute",
                right: "10px",
                top: "0",
                height: "100%",
                fontSize: "1.2rem",
                display: "flex",
                alignItems: "center",
                color: "var(--ion-color-bhp-gray)",
              }}
            >
              {!!preEmptiveSearch && (
                <>
                  <IonIcon
                    icon={close}
                    color="danger"
                    onClick={() => {
                      setPreEmptiveSearch("");
                    }}
                  />
                  <div style={{ width: "10px" }}></div>
                </>
              )}
              <IonIcon icon={micSharp} />
            </div>
            {preemptiveListJsx}
            <input
              // onClick={props.onSearchClick}
              className="bhp-first-fold-page-top-search"
              placeholder="Search for Products / Shops"
              value={preEmptiveSearch}
              onChange={(e) => {
                // if (!!inPageSearch) {
                //   setSearch(e.target.value);
                //   return;
                // }
                // This guard to prevent and overide of value for when the preemptive
                // is written from searchBackend function whcih will again trigger the premptive
                setPreEmptiveSearch(e.target.value);
              }}
              onKeyDown={(e) => {
                // if (!!inPageSearch) return;
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (!preEmptiveSearch) {
                    stringToast("Please enter valid search input!");
                    return;
                  }
                  searchBackend(preEmptiveSearch);
                  // } else {
                  //   if (!!timeoutRef.current) {
                  //     clearTimeout(timeoutRef.current);
                  //   }
                  //   timeoutRef.current = setTimeout(triggerBackendSearch, 800);
                }
              }}
            />
            <div>
              <div className="bhp-first-fold-action-button"></div>
            </div>
          </div>
        )}
        {props.businessDetails.subType !== "BNI-CHAPTER" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "30px",
            }}
          >
            <div
              className="bhp-first-fold-button"
              style={{
                background: props?.ctaBtnBg,
                color: props?.ctaBtnColor,
              }}
              onClick={props.onPrimaryButtonClick}
            >
              <IonIcon
                icon={
                  props?.vypzeePage
                    ? location
                    : props.businessDetails.isMarket &&
                      props.businessDetails.marketType === "RWA"
                    ? searchSharp
                    : documentText
                }
                style={{
                  color: props?.ctaBtnColor
                    ? props?.ctaBtnColor
                    : props?.headerFontColor
                    ? props.headerFontColor
                    : "var(--ion-color-bhp-vypzee-dark)",
                }}
              />
              <span style={{ paddingLeft: "5px" }}>
                {!!props.vypzeePage
                  ? "Local Markets"
                  : props?.marketCluster
                  ? "All Markets"
                  : props.businessDetails.marketType === "RWA"
                  ? "Search"
                  : "Market Directory"}
              </span>
            </div>
            <div style={{ width: "15px" }}></div>
            <div
              className="bhp-first-fold-button"
              style={{
                background: props?.ctaBtnBg,
                color: props?.ctaBtnColor,
              }}
              onClick={props.onSecondaryButtonClick}
            >
              <IonIcon
                icon={
                  props.vypzeePage || props?.marketCluster ? pricetag : navigate
                }
                style={{
                  color: props?.ctaBtnColor
                    ? props?.ctaBtnColor
                    : props?.headerFontColor
                    ? props.headerFontColor
                    : "var(--ion-color-bhp-vypzee-dark)",
                }}
              />
              <span style={{ paddingLeft: "5px" }}>
                {!!(props.vypzeePage || props.marketCluster)
                  ? "Offers"
                  : "Navigation"}
              </span>
            </div>
          </div>
        )}
      </div>
      <div ref={pageHeaderRef}> </div>
      <div
        className="bhp-first-fold-footer"
        style={{
          display: !props.businessDetails.isMarket ? "none" : undefined,
        }}
      >
        {!props.vypzeePage && (
          <>
            <div
              style={{
                position: "absolute",
                top: "-5px",
                left: 0,
                width: "100%",
                height: "10px",
                zIndex: 4,
                background: "var(--ion-color-bhp-white)",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 3,
                background:
                  "linear-gradient(to bottom, var(--ion-color-bhp-white) 0%, var(--ion-color-bhp-white) 10%, rgba(var(--ion-color-bhp-white-rgb),0.2) 80%, transparent 100%)",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 2,
              }}
            >
              <img
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: props?.vypzeePage ? "contain" : "cover",
                }}
                src={props.logoImgData}
                alt=""
              />
            </div>
          </>
        )}
        <div style={{ height: "70px" }}></div>
        {!!props?.hideFooter && !!props?.footerOverride?.image && (
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              zIndex: 5,
              left: 0,
              display: "flex",
              justifyContent: props?.footerOverride?.imagePosition
                ? props?.footerOverride?.imagePosition
                : "center",
              width: "100%",
              padding: "0 15px",
              // background: "red",
            }}
            onClick={() => {
              if (!props?.footerOverride?.url) return;
              window.location.assign(props?.footerOverride?.url);
            }}
          >
            <div
              style={{
                width: "140px",
                height: "56px",
                border: "1px solid gray",
                borderRadius: "10px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              }}
            >
              <img
                src={`${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props?.footerOverride?.image?.fileName}&percentage=40&${AUTH_PARAMS}&`}
                alt=""
                style={{ height: "100%", width: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
        )}
        {/* {!props?.hideFooter && ( */}
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            zIndex: 5,
            left: 0,
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              color:
                !props.logoImgData || props.vypzeePage
                  ? "var(--ion-color-bhp-dark)"
                  : "var(--ion-color-light)",
              padding: "10px",
              backgroundColor:
                !props.logoImgData || props.vypzeePage
                  ? undefined
                  : "rgba(0,0,0,0.7)",
              borderRadius: "10px",
            }}
          >
            {!props.vypzeePage
              ? props?.marketCluster
                ? `All ${props.businessDetails.name} Markets In One Place`
                : `Views: ${
                    props.visitCount?.marketVisits
                      ? props.visitCount.marketVisits
                      : "-"
                  }`
              : `Looking for something in Local Markets?`}
            {(!props.logoImgData || props.vypzeePage) &&
              props.businessDetails.subType !== "BNI-CHAPTER" && (
                <p
                  style={{
                    color: props.headerFontColor
                      ? props.headerFontColor
                      : "var(--ion-color-bhp-vypzee-dark)",
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                  }}
                >
                  {`${
                    props?.vypzeePage
                      ? "Search & Find on Vypzee"
                      : props.businessDetails.marketType === "RWA"
                      ? "Resident Directory"
                      : "Market Exploration Never Been This Easy"
                  }.`}
                </p>
              )}
          </div>
        </div>
        {/* )} */}
      </div>
      <Suspense fallback={<LazyLoaderSpinner />}>
        {!!props?.campaignData &&
          props.businessDetails?.isMarket &&
          props?.adData?.length > 0 && (
            <BhpTicker
              adData={props.adData}
              offerName={props.campaignData.campaignName}
              bgColor={props.campaignData?.bgColor}
              textColor={props.campaignData?.textColor}
              separatorImage={props.campaignData?.image}
              onClick={props.openAllCampaignPromo}
              businessDetails={props.businessDetails}
            />
          )}
      </Suspense>
    </div>
  );
};

export default BhpFirstFoldPage;
